/**
 * Converts Greek text to uppercase while properly removing stress marks (τονισμός)
 * according to Greek orthography rules
 */
export const toGreekUpperCase = (text: string): string => {
  const greekStressMap: { [key: string]: string } = {
    'ά': 'Α', 'έ': 'Ε', 'ή': 'Η', 'ί': 'Ι', 'ό': 'Ο', 'ύ': 'Υ', 'ώ': 'Ω',
    'ΐ': 'Ι', 'ΰ': 'Υ', // Diaeresis with stress
    'Ά': 'Α', 'Έ': 'Ε', 'Ή': 'Η', 'Ί': 'Ι', 'Ό': 'Ο', 'Ύ': 'Υ', 'Ώ': 'Ω'
  };

  return text
    .split('')
    .map(char => greekStressMap[char] || char.toUpperCase())
    .join('');
};